export default class MeetingTopic {
}
